import React, { Component } from 'react'
import sortBy from 'lodash/sortBy'
import PropTypes from 'prop-types'
import { SEARCH_RESULTS_ROUTE } from 'shared/services/routes'
import './style.css'

export default class SearchBar extends Component {
  static propTypes = {
    isNoResultsVisible: PropTypes.bool.isRequired,
    query: PropTypes.string,
    resetSearchBarResults: PropTypes.func.isRequired,
    results: PropTypes.array,
    selectSearchResult: PropTypes.func.isRequired
  }

  static defaultProps = {
    isNoResultsVisible: false,
    query: ''
  }

  componentDidMount () {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleInputChange = (event) => this.props.getSearchBarResults(event.target.value)

  handleResultClick = (id, name, type) => () => this.props.selectSearchResult(id, name, type)

  handleClickOutside = (event) => {
    (
      this.searchBarContainer &&
      !this.searchBarContainer.contains(event.target) &&
      this.props.resetSearchBarResults()
    )
  }

  render () {
    return (
      <div className='search-bar-container d-none d-sm-block'>
        <i className='far fa-search search-bar-icon' />
        <input
          className='search-bar-input'
          onChange={this.handleInputChange}
          placeholder="Rechercher dans l'assistance"
          value={this.props.query}
          type='text' />
        {
          this.props.location !== SEARCH_RESULTS_ROUTE && this.props.query && this.props.results.length > 0 &&
          <div
            className='results-container'
            ref={(node) => { this.searchBarContainer = node }}>
            {
              sortBy(this.props.results, 'groupTitle').map((group, i) => (
                <div key={i}>
                  <p className='results-group-title'>{group.groupTitle}</p>
                  {sortBy(group.elements, 'name').map(element => (
                    <p
                      className='result-element'
                      key={element.id}
                      onClick={this.handleResultClick(element.id, element.name, element.widget_type)}>
                      {element.name}
                    </p>
                  ))}
                </div>
              ))
            }
          </div>
        }
        {
          this.props.query && this.props.isNoResultsVisible &&
          <div className='results-container'>
            <p className='no-results'>Aucun résultat ne correspond à votre recherche</p>
          </div>
        }
      </div>
    )
  }
}
